import { Card, Paper, Stack, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { LineItemActionsList } from "./ActionsList";
import { useGetLineItemLayoutsQuery } from "../features/model/lineitemSlice";

const LineItemHeaders = () => {
    return <TableHead key={"headers"}><TableRow>
        <TableCell>SKU</TableCell>
        <TableCell>Quantity</TableCell>
        <TableCell>Customizations</TableCell>
        <TableCell>Processed</TableCell>
        <TableCell>Engraving</TableCell>
        </TableRow></TableHead>;
};

const LineItemCustomizations = ({data}) => {
    const raw_items = JSON.parse(data);
    let isLCC = (process.env.REACT_APP_PREFIX.includes("lcc"));

    function roundAtThree(text) {
        const fl = parseFloat(text);
        if(fl) {
            if(String(text).includes("."))
                return `${fl.toPrecision(3)}`;
        }
        return text;
    }

    function makeLabel(text) {
        return text.replaceAll("_", " ");
    }
    /*
    if(isLCC) {
        return <Typography>Many</Typography>;
    }*/

    const items = Object.fromEntries(
        Object.entries(raw_items).filter(([key]) => !key.startsWith("_"))
    );

    return Object.keys(items).sort().map((key, i) => {
        return <Stack key={`item_${i}`} direction="row" sx={{alignItems: "baseline", display: "flex", marginBottom: 1}}>
            <Typography variant="h4" sx={{marginRight: 1}}>{makeLabel(key)}:</Typography>
            <Typography variant="p">{roundAtThree(items[key])}</Typography>
            </Stack>
    })
};

const LineItemPreviewCard = ({lineitem}) => {
    const {data: layouts, error, isLoading } = useGetLineItemLayoutsQuery(lineitem.id)
    if (isLoading || error) {
        return <></>;
    }
    if(layouts.objects.length === 0) {
        return <></>;
    }

    return <Stack direction="column" spacing={1}>
            {
                layouts.objects.map((layout, i) => {
                    return <img key={`img_${i}`} alt="layout" width={128} style={{width: "128", height: "128", objectFit: "scale-down"}} src={`${process.env.REACT_APP_API_URL}v1/lipreview/256/${lineitem.id}/${i}`} />
                })
            }
        </Stack>
}

const LineItemRow = ({object, showActions=false}) => {
    if (!object) {
        return <TableRow><TableCell>...</TableCell></TableRow>
    }
    let isLCC = (process.env.REACT_APP_PREFIX.includes("lcc"));
    let preview = isLCC ? <></> : <LineItemPreviewCard lineitem={object} />;

    let lineitemRows = [
        <TableRow key={`row_${object.id}`}>
            <TableCell><Typography noWrap>{(object.SKU.name !== "") ? object.SKU.name : object.description}</Typography></TableCell>
            <TableCell><Typography>{object.quantity}</Typography></TableCell>
            <TableCell><LineItemCustomizations data={object.customization} /></TableCell>
            <TableCell><Typography>{object.processed * object.quantity} / {object.quantity}</Typography></TableCell>
            <TableCell>{preview}</TableCell>
        </TableRow>
    ];

    if (showActions) {
        lineitemRows.push(<TableRow key="actions">
            <TableCell colSpan={4}>
                <LineItemActionsList lineitem={object} />
            </TableCell>
        </TableRow>);
    }

    return lineitemRows;
};

export { LineItemHeaders, LineItemRow };
